module.exports = __webpack_public_path__ + "img/2-bottom.4f3566c9.png";